export default __webpack_public_path__ + "static/media/level-5.09a486c4.png";